import { Card, Grid } from "@material-ui/core";
import { FC } from "react";
import * as Icons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from '@material-ui/core/styles';
import { ThemeComponent } from "../Types";

type WidgetCardPropType = {
  componentDetails: ThemeComponent;
  handleSelectedComponentChange: any;
  selectedComponent: null | string;
};

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '0.875rem',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  description: {
    fontSize: '0.7rem',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  selectedCard: {
    backgroundColor: '#e3f2fd',
    border: '2px solid black',  // Selected card - black border
    marginTop: '2px',
  },
  card: {
    border: '1px solid grey',   // Unselected card - grey border
    marginTop: '2px',
  },
}));

const getIcon = (iconName: string): IconDefinition | undefined => {
  const icon = Icons[iconName as keyof typeof Icons];
  return icon && typeof icon === 'object' && 'iconName' in icon ? icon as IconDefinition : undefined;
};

const WidgetCard: FC<WidgetCardPropType> = ({
  componentDetails,
  handleSelectedComponentChange,
  selectedComponent
}) => {
  const isSelected = componentDetails.ThemeComponentKey === selectedComponent;
  const classes = useStyles();

  return (
    <Card
      sx={{
        alignItems: 'center',
        minHeight: componentDetails.Description ? '80px' : '50px',
        cursor: 'pointer',
        padding: '8px'
      }}
      className={isSelected ? classes.selectedCard : classes.card}
      onClick={() => handleSelectedComponentChange(componentDetails.ThemeComponentKey)}
    >
      <Grid container alignItems="center" style={{ height: '100%' }}>
        <Grid item xs={3} container justifyContent="center" alignItems="center">
          {componentDetails.IconName && getIcon(componentDetails.IconName) && (
            <FontAwesomeIcon icon={getIcon(componentDetails.IconName)!} />
          )}
        </Grid>
        <Grid
          item xs={9}
          container
          direction="column"
          justifyContent="center"
        >
          <Grid item>
            <div className={classes.label}>{componentDetails.ComponentLabel}</div>
          </Grid>
          <Grid item>
            <div className={classes.description}>{componentDetails.Description ?? ''}</div>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default WidgetCard;
